module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('header', {
    staticClass: "codice-header"
  }, [_c('h1', {
    staticClass: "codice-title"
  }, [_vm._v("Nepohualtzintzin")]), _vm._v(" "), _c('p', {
    staticClass: "codice-subtitle"
  }, [_vm._v("ábaco mesoamericano")]), _vm._v(" "), _c('svg', {
    staticClass: "codice-glyph",
    attrs: {
      "viewBox": "0 0 120 14",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2 11 L18 11 L18 5 L26 5 L26 11 L34 11",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "46",
      "cy": "7",
      "r": "1.6",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54 7 L60 1 L66 7 L60 13 Z",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "74",
      "cy": "7",
      "r": "1.6",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86 11 L94 11 L94 5 L102 5 L102 11 L118 11",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "square"
    }
  })])]), _vm._v(" "), _c('abacus'), _vm._v(" "), _c('div', {
    staticClass: "codice-readings"
  }, [_c('div', {
    staticClass: "reading reading--vigesimal"
  }, [_c('span', {
    staticClass: "reading__label"
  }, [_vm._v("Vigesimal")]), _vm._v(" "), _c('span', {
    staticClass: "reading__value"
  }, [_vm._v(_vm._s(_vm._f("toBaseTwenty")(_vm.value)))]), _vm._v(" "), _c('span', {
    staticClass: "reading__caption"
  }, [_vm._v("base veinte")])]), _vm._v(" "), _c('div', {
    staticClass: "codice-readings__divider",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 8 80",
      "preserveAspectRatio": "none"
    }
  }, [_c('line', {
    attrs: {
      "x1": "4",
      "y1": "0",
      "x2": "4",
      "y2": "80",
      "stroke": "currentColor",
      "stroke-width": "0.6",
      "stroke-dasharray": "2 4"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "4",
      "cy": "40",
      "r": "2",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "reading reading--decimal"
  }, [_c('span', {
    staticClass: "reading__label"
  }, [_vm._v("Decimal")]), _vm._v(" "), _c('input', {
    staticClass: "reading__input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.setNumber($event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reading__caption"
  }, [_vm._v("base diez")])])]), _vm._v(" "), _c('challenge-mode')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f20c7c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 64
// module chunks = 2